import script from "./RankList.vue?vue&type=script&setup=true&lang=js"
export * from "./RankList.vue?vue&type=script&setup=true&lang=js"

import "./RankList.vue?vue&type=style&index=0&id=ae4b9b36&scoped=true&lang=css"

import exportComponent from "/Users/lee/web_app/heroineweb/heroineweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae4b9b36"]])

export default __exports__